import classNames from "classnames"
import { useCallback } from "react"
import { useSectionDispatch } from "../../context/SectionContextProvider"
import { FormRow as FormRowType } from "../../types/FormRow"
import { Question } from "../../types/SectionState"
import { FormQuestion } from "../FormQuestion"

interface Props {
  row: FormRowType
  className?: string
  sectionName: string
}

export function FormRow({ row, className, sectionName }: Props) {
  const dispatch = useSectionDispatch()

  const onValidate = useCallback(
    (question: Question) =>
      dispatch({
        type: "SET_QUESTION",
        question,
      }),
    [dispatch],
  )

  return (
    <div className={classNames("flex gap-x-7 lg:flex-row flex-col", className)}>
      {row.form_questions.map((question, index) => {
        return (
          <div
            key={question.mapped_field + index}
            className="flex flex-col w-full my-2 mb-[40px]"
          >
            <FormQuestion
              question={question}
              sectionName={sectionName}
              onValidate={onValidate}
              onBlur={onValidate}
            />
          </div>
        )
      })}
    </div>
  )
}
